<a
  [routerLink]="[]"
  fragment="main-content"
  (click)="setFocusOnMainContent()"
  class="visually-hidden-focusable skip-link"
  wlTrackLink
  [trackLinkInfo]="{
    rendering: { componentName: 'SkipLinkComponent' },
    field: 'skip to main content',
    eventType: 'link-click',
    type: 'navigation',
  }"
  wlAutomationId="skip-to-main-content"
  >Direct naar hoofdinhoud</a
>
@if (!disableSkipToLogin()) {
  <a
    [href]="loginUrl()"
    class="visually-hidden-focusable skip-link"
    wlTrackLink
    [trackLinkInfo]="{
      rendering: { componentName: 'SkipLinkComponent' },
      field: 'skip to login',
      eventType: 'link-click',
      type: 'navigation',
    }"
    wlAutomationId="skip-to-login"
    >Direct naar inloggen</a
  >
}
